// extracted by mini-css-extract-plugin
export var label = "_hw-0";
export var treatmentCard = "_hw-1";